import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\">\n<path d=\"M32 18.6278L27.5854 14.2623L20.2093 21.5565L12.8145 14.2623L8.39996 18.6278L15.7761 25.922L8.39996 33.2162L12.8145 37.6001L20.2093 30.2874L27.5854 37.6001L32 33.2162L24.6238 25.922L32 18.6278Z\" fill=\"black\" />\n<path d=\"M19.4083 2.40002H14.1183V10.7626H19.4083V2.40002Z\" fill=\"black\" />\n<path d=\"M26.2815 2.40002H20.9916V10.7626H26.2815V2.40002Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol